export default __webpack_public_path__ + "static/media/serialNumber1.56691228.png";